import React, {FormEvent, useContext, useState} from "react";
import {Icon, message} from "antd";
import {WechatBindFormPropsType, withWechatBindForm} from "../../hoc/withWechatBindForm";
import CountDownButton from "../CountDownButton";
import {useIntl} from "react-intl";

const BasWechatBindForm: React.FC<WechatBindFormPropsType> = (props) => {
    const {username, mailCode, changeUsername, changeMailCode, bindLoading, onSendMailCode} = props
    let intl = useIntl();
    return (
            <>
                <div className={'input'}>
                    <Icon type="user" />
                    <input
                        placeholder={intl.formatMessage({id: "用户名"})}
                        value={username}
                        onChange={changeUsername}
                    />
                </div>
                <div className={'input'}>
                    <Icon type="mail" />
                    <input
                        placeholder={intl.formatMessage({id: "邮箱验证码"})}
                        value={mailCode}
                        onChange={changeMailCode}
                    />
                    <CountDownButton onClick={onSendMailCode} text={intl.formatMessage({id: "发送"})} style={{whiteSpace: 'nowrap'}} />
                </div>
                <button type="submit" className={'submit'} disabled={bindLoading}>
                    {bindLoading ? <Icon type="loading" /> : ''}{intl.formatMessage({id: "绑 定"})}
                </button>
            </>
    )
}

export default withWechatBindForm(BasWechatBindForm)
